module.exports = __webpack_public_path__ + "img/TA.0930b424.png";